import React from 'react';
import { useModalMethods } from '../../../../shared/packages/modalManager';
import { modalNames } from '../../../../shared/configs/modal';
import { useFormMethods } from '../../../../../../helpers/formManager';
import { SubmitProvider, SubmitContext } from './SubmitProvider';
import { FormProvider } from './FormProvider';
import { ModalPropsProvider, ModalPropsContext } from './ModalPropsProvider';
import FormComponent from './FormComponent';

const Provider = ({ children }) => {
  return (
    <SubmitProvider>
      <FormProvider>
        <ModalProvider>{children}</ModalProvider>
      </FormProvider>
    </SubmitProvider>
  );
};

function ModalProvider({ children }) {
  const { reset } = useFormMethods();

  const { removeProps } = useModalMethods();

  const handleReset = () => {
    reset({});
    removeProps(modalNames.attachmentsForm);
  };

  return (
    <ModalPropsProvider reset={handleReset}>{children}</ModalPropsProvider>
  );
}

const EditAttachmentStrategy = {
  Provider,
  SubmitContext,
  ModalPropsContext,
  fields: <FormComponent />,
};

export default EditAttachmentStrategy;
